import type { AxiosResponse } from 'axios';

import { useAuthStore } from '#ui-shared/stores/auth-store';

export function bearerOverrideResponseInterceptor() {
  const authStore = useAuthStore();

  return (response: AxiosResponse) => {
    if (response.headers['nora-bearer-override']) {
      authStore.updateToken(response.headers['nora-bearer-override']);
    }

    return response;
  };
}
